import { SystemTypes } from 'spark-core-dx/services';

const fullOperatorMap = {
    'equals': '=',
    'on': '=',
    'before': '<',
    'after': '>',
    'on and before': '<=',
    'on and after': '>=',
    'is': '=',
    'is not': '!='
}

export const getOperatorsByType = (format) => {
    const operatorMap = {
        f0: ['>', '>=', '=', '<=', '<'],
        r1: ['>', '>=', '=', '<=', '<'],
        r2: ['>', '>=', '=', '<=', '<'],
        r3: ['>', '>=', '=', '<=', '<'],
        r4: ['>', '>=', '=', '<=', '<'],
        s: ['contains', 'starts with', 'ends with', 'equals'],
        dt1: ['on', 'before', 'after', 'on and before', 'on and after'],
        dt2: ['on', 'before', 'after', 'on and before', 'on and after'],
        dt3: ['on', 'before', 'after', 'on and before', 'on and after'],
        dt4: ['on', 'before', 'after', 'on and before', 'on and after'],
        b: ['is', 'is not']
    };

    const operators = operatorMap[format] || operatorMap['s'];
    return operators.map(op => ({
        Text: op,
        Value: fullOperatorMap[op] ?? op
    }));
}

export const getValueMetadata = (format) => {
    switch (format) {
        case "dt1":
        case "dt2":
        case "dt3":
        case "dt4":
            return {
                FieldType: SystemTypes.UIFieldType.Date,
                FieldName: "Value",
            }
        case "b":
            return {
                FieldType: SystemTypes.UIFieldType.SelectList,
                FieldName: "Value",
                DataJson: [{
                    Text: "True",
                    Value: "true"
                }, {
                    Text: "False",
                    Value: "false"
                }]
            }
        case "f0":
        case "s":
        default:
            return {
                FieldType: SystemTypes.UIFieldType.TextBox,
                FieldName: "Value",
            }
    }
}